export function renderBullet(swiper, index, className) {
  function updateButton() {
    let numberOfSlides = swiper.slides.length
    let slide = [...swiper.slides].find(
      slide => slide.getAttribute('aria-label') === `${String(index + 1)} / ${numberOfSlides}`,
    )

    let bullet = swiper.pagination.bullets[index]
    bullet.setAttribute('aria-disabled', String(index === swiper.realIndex))
    bullet.setAttribute('aria-label', slide.getAttribute('aria-label'))
  }

  swiper.on('slideChange', updateButton)
  swiper.on('afterInit', updateButton)

  return `<button class="${className}"></button>`
}
